import { render, staticRenderFns } from "./AudienceFilterBrickSettings.vue?vue&type=template&id=04d8caf3&scoped=true&"
import script from "./AudienceFilterBrickSettings.vue?vue&type=script&lang=js&"
export * from "./AudienceFilterBrickSettings.vue?vue&type=script&lang=js&"
import style0 from "./AudienceFilterBrickSettings.vue?vue&type=style&index=0&id=04d8caf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d8caf3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04d8caf3')) {
      api.createRecord('04d8caf3', component.options)
    } else {
      api.reload('04d8caf3', component.options)
    }
    module.hot.accept("./AudienceFilterBrickSettings.vue?vue&type=template&id=04d8caf3&scoped=true&", function () {
      api.rerender('04d8caf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/AudienceFilter/AudienceFilterBrickSettings.vue"
export default component.exports